import React, { useCallback, useMemo, useState } from 'react';
import { AppButton, Box, FiservCardInterface, FiservCardStatusEnum, FraudIcon, Text } from '@common-fe/common-fe';

import ConfirmFraudOnCardModal from '../ConfirmFraudOnCardModal/ConfirmFraudOnCardModal';

interface Props {
  isStandaloneMode?: boolean;
  selectedCard?: FiservCardInterface;
}
export const CardDetailsHeader: React.FC<Props> = ({ isStandaloneMode, selectedCard }) => {
  const [isConfirmFraudModalVisible, setIsConfirmFraudModalVisible] = useState(false);

  const handleOpenConfirmFraudModal = useCallback(() => {
    setIsConfirmFraudModalVisible(true);
  }, []);

  const showConfirmFraudOnCardButton = useMemo(() => (selectedCard?.status === FiservCardStatusEnum.LOST
    || selectedCard?.status === FiservCardStatusEnum.STOLEN)
    && !selectedCard?.fraudConfirmed,
  [selectedCard?.status, selectedCard?.fraudConfirmed]);

  if (!isStandaloneMode) {
    return null;
  }

  return (
    <>
      <Box
        margin={{ vertical: 'spacing16' }}
        direction="row"
        justify="between"
        align="center"
        data-testid="CardDetailsHeader-wrapper"
      >
        <Text size="20px" weight="bold" data-testid="CardDetailsHeader-holder-name">
          Cards
        </Text>
        <Box direction="row" justify="end" align="center">
          {showConfirmFraudOnCardButton ? (
            <AppButton
              testId="open_confirm-fraud-on-card-modal"
              buttonType="secondary"
              color="red"
              rightIcon={<FraudIcon width="24px" height="24px" color="iconPrimary" />}
              onClick={handleOpenConfirmFraudModal}
            >
              Confirm Fraud on Card
            </AppButton>
          ) : null}
        </Box>
      </Box>

      {isConfirmFraudModalVisible && selectedCard?.id ? (
        <ConfirmFraudOnCardModal
          cardId={selectedCard?.id}
          onSetVisible={setIsConfirmFraudModalVisible}
        />
      ) : null}
    </>
  );
};
